define('auth2',["require", "exports", "./notifications", "./util/http", "./util/log"], function (require, exports, notifications, http_1, log) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.complete = exports.init = void 0;
    var apiKey = "AIzaSyDfMYHOQCbCsMpm-pjNlcrBtqgAfO58wDo";
    var authOptions = {
        client_id: "1025187389465-71cuhba0pqbuq2im4ldm1kj710q4oefb.apps.googleusercontent.com",
        scope: "profile email"
    };
    function init() {
        // Sign in buttons
        window.signIn = function () { return clickSignIn(); };
        window.signOut = function () { return clickSignOut(); };
        // If dom loaded, init now, else wait
        if (document.readyState === "complete") {
            start();
        }
        else {
            window.addEventListener("load", function () {
                // Start auth 1 cycle after load
                setTimeout(start, 0);
            });
        }
    }
    exports.init = init;
    /**
     * Called when oauth flow is complete
     */
    function complete() {
        // On safari, auth doesn't load correctly, so get token from hash directly
        var id_token = location.hash
            .split("&")
            .filter(function (p) { return p.startsWith("id_token="); })
            .map(function (p) { return p.replace("id_token=", ""); })[0];
        getAuthInstance().then(function (authInstance) {
            if (authInstance.isSignedIn.get()) {
                updateSignInStatus(true);
            }
            else {
                // Send token to baseline server
                postAuth(id_token);
            }
        });
    }
    exports.complete = complete;
    function start() {
        if (window.gapi === undefined) {
            console.error("google client not initialized");
        }
        // Only check with google if not signed in with baseline cookie
        if (!window.baselineSignedIn) {
            getAuthInstance().then(function (authInstance) {
                // Listen for sign-in state changes
                authInstance.isSignedIn.listen(updateSignInStatus);
                // Handle the initial sign-in state
                updateSignInStatus(authInstance.isSignedIn.get());
            }).catch(function () { });
        }
        if (window.startGA) {
            window.startGA();
        }
    }
    /**
     * Get AuthInstance as a promise
     */
    function getAuthInstance() {
        return new Promise(function (resolve, reject) {
            if (window.gapi) {
                gapi.load("client:auth2", function () {
                    gapi.client.setApiKey(apiKey);
                    gapi.auth2.init(authOptions).then(function () {
                        resolve(gapi.auth2.getAuthInstance());
                    }).catch(function (e) {
                        if (e && e.details === "Cookies are not enabled in current environment.") {
                            console.error("authentication failed: cookies not enabled");
                            reject("authentication failed: cookies not enabled");
                        }
                        else {
                            log.error("google auth init failed " + JSON.stringify(e));
                            reject(e.details || "authentication error");
                        }
                    });
                });
            }
            else {
                reject("google auth not initialized");
            }
        });
    }
    /**
     * Handle sign-in state changes
     */
    function updateSignInStatus(isSignedIn) {
        if (isSignedIn) {
            // Google auth signed in, sign into baseline
            // Get token
            var authInstance = gapi.auth2.getAuthInstance();
            var user = authInstance.currentUser.get();
            var authResponse = user.getAuthResponse();
            var id_token = authResponse.id_token;
            // Send token to baseline server
            postAuth(id_token);
        }
        else {
            // Not signed in, sign out of baseline server
            // Also called when a user clicked signout
            if (window.baselineSignedIn) {
                baselineSignout();
            }
        }
    }
    /**
     * Send id token to baseline server to get a cookie
     */
    function postAuth(token) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/auth/web/token", true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var result = JSON.parse(xhr.responseText);
                    // Check reload status
                    if (window.location.pathname === "/auth/complete") {
                        // Redirect to user tracks page
                        window.location.href = "/users/" + result.userId;
                    }
                    else if (result.reload || !window.baselineSignedIn) {
                        window.location.reload();
                    }
                }
                else {
                    notifications.error("Sign in failed: baseline auth error");
                }
            }
        };
        xhr.send(token);
    }
    function clickSignIn() {
        log.info("sign in");
        getAuthInstance().then(function (authInstance) {
            authInstance.signIn({
                ux_mode: "redirect",
                redirect_uri: window.location.origin + "/auth/complete"
            }).catch(function (error) {
                if (error && error.error) {
                    var errorMessage = error.error.replace(/_/g, " ");
                    notifications.error("Sign in failed: " + errorMessage);
                }
                else {
                    notifications.error("Sign in failed");
                }
            });
        }).catch(function (e) {
            notifications.error("Sign in failed: " + e);
            // Redirect to email sign in page
            window.location.href = "/auth/magic#" + e.replace(/ /g, "_");
        });
    }
    function clickSignOut() {
        log.info("sign out");
        // Sign out of google
        getAuthInstance().then(function (authInstance) {
            authInstance.signOut().then(function () {
                // Sign out of baseline
                baselineSignout();
            });
        }).catch(function () {
            // Couldn't sign out of google, at least sign out of baseline
            baselineSignout();
        });
    }
    /**
     * Sign out of baseline server
     */
    function baselineSignout() {
        (0, http_1.getJson)("/auth/signout").then(function (result) {
            if (result.reload) {
                window.location.href = "/";
            }
        }).catch(function () {
            notifications.error("Sign out failed");
        });
    }
});
//# sourceMappingURL=/assets/javascripts/auth2.js.map;
